var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/refresh"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.1667 3.33333V8.33333H14.1667",
    stroke: "#DC6803",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.833333 16.6667V11.6667H5.83333",
    stroke: "#DC6803",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.925 7.5C3.34764 6.30565 4.06594 5.23784 5.01289 4.39618C5.95983 3.55453 7.10455 2.96647 8.34024 2.68688C9.57592 2.40729 10.8623 2.44528 12.0793 2.79731C13.2964 3.14934 14.4044 3.80393 15.3 4.7L19.1667 8.33333M0.833333 11.6667L4.7 15.3C5.59562 16.1961 6.70364 16.8507 7.92067 17.2027C9.1377 17.5547 10.4241 17.5927 11.6598 17.3131C12.8954 17.0335 14.0402 16.4455 14.9871 15.6038C15.9341 14.7622 16.6524 13.6943 17.075 12.5",
    stroke: "#DC6803",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.775b1bfb24176a9fe0638162ff1b2f69.svg";
export { ForwardRef as ReactComponent };